// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sxL_z","col":"styles_col__3BudR"};